export default function MySQL_CASE() {
  return (
    <div>
      <h2>MySQL_CASE</h2>    </div>
  );
}